import { Suspense, lazy } from 'react';
import './App.scss';
import { usePlatform } from './shared/hooks';
import { AppProvider } from './shared/provider/AppProvider';
import { PlatformType } from '@src/container/type';
import { ErrorBoundary } from './shared/components/ErrorBoundary/ErrorBoundary';
import { StyledProvider } from '@abtasty/design-system';

const FsApp = lazy(() => import('./flagship/App'));
const TagApp = lazy(() => import('./tag/App'));
const PlatformChoice = lazy(() => import('./shared/PlatformChoice/PlatformChoice'));
const FsToken = lazy(() => import('./shared/pages/FsToken'));

const componentMap = {
  BOTH: PlatformChoice,
  FS: FsApp,
  TAG: TagApp,
  FS_TOKEN: FsToken,
};

const Wrapper = () => {
  const platformType = usePlatform() as PlatformType;

  const CurrentComponent = componentMap[platformType];
  return (
    <Suspense fallback={null}>
      <ErrorBoundary>
        <StyledProvider>
          <CurrentComponent />
        </StyledProvider>
      </ErrorBoundary>
    </Suspense>
  );
};

export const App = () => {
  return (
    <ErrorBoundary>
      <AppProvider>
        <Wrapper />
      </AppProvider>
    </ErrorBoundary>
  );
};
